import { observer } from 'mobx-react-lite'
import React from 'react'
import NonMediaAction from './NonMediaAction'

export default observer(function NonMediaActions({ actions, campaignScenario, actionGroup, }) {

  return (
    <div className="p-4 overflow-x-auto">
      <table className="w-full dark:border dark:border-rb-dark-mode-lighter">
        <thead>
          <tr className="bg-gray-200 dark:bg-rb-dark-mode-lighter">
            <td className="py-3 px-1 text-xs w-3/4 dark:text-white"></td>
            <td className="py-3 px-1 text-xs font-bold whitespace-normal w-1/4 dark:text-white">Price</td>
          </tr>
        </thead>
        <tbody>
          { actions.map(action => <NonMediaAction key={action.id} action={action} campaignScenario={campaignScenario} />)}
        </tbody>
      </table>
    </div>
  )
})